import lodash from "lodash";

/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:23:50
 * @modify date 2021-08-23 11:23:50
 * @desc [工具库]
 */
export class Utils {
  /**
   * 转化 object 为只读
   * @static
   * @param {*} obj
   * @param {(v) => void} [set] set 触发函数
   * @memberof Utils
   */
  static toReadonly(obj, set?: (k, v) => void) {
    if (lodash.isObject(obj)) {
      lodash.mapKeys(obj, (val, key) => {
        Utils.toReadonly(val, set);
        Object.defineProperty(obj, key, {
          // writable: false,
          // configurable: false,
          get() {
            return val;
          },
          set(newValue) {
            if (lodash.isFunction(set)) {
              set(key, newValue);
            } else {
              console.warn(
                ` 属性 【 ${key} 】 不可变 请 lodash.merge | assign ({},[当前属性值],newValue) 使用`
              );
            }
          },
        });
      });
    }
    return obj;
  }

  /**
   * 数字金额格式化 $1,222,222.00
   * @static
   * @param {value} 数字 1222222
   * @param {currency} 货币单位 $
   * @param {decimals} 保留几位小数 2
   * @memberof Utils
   */
  static currency(value, currency?, decimals?) {
    value = parseFloat(value);
    if (!isFinite(value) || (!value && value !== 0)) return "";
    currency = currency != null ? currency : "";
    decimals = decimals != null ? decimals : 2;
    let stringified = Math.abs(value).toFixed(decimals);
    let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    let i = _int.length % 3;
    let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? "," : "") : "";
    let _float = decimals ? stringified.slice(-1 - decimals) : "";
    let sign = value < 0 ? "-" : "";
    return `${sign}${currency}${head}
    ${_int.slice(i).replace(/(\d{3})(?=\d)/g, "$1,")}${_float}`;
  }
}
